const SUB_KEYS = ['price', 'ambiance', 'crowd', 'service', 'drinkSelection'];

export function getFilledSubRatings(subs = {}) {
  return SUB_KEYS
    .map((key) => Number(subs[key]))
    .filter((value) => Number.isFinite(value) && value > 0);
}

export function computeOverallRating(subs = {}) {
  const filled = getFilledSubRatings(subs);
  if (filled.length === 0) return 0;
  const average = filled.reduce((sum, value) => sum + value, 0) / filled.length;
  return Math.round(average * 100) / 100;
}

export function hasAnySubRating(subs = {}) {
  return getFilledSubRatings(subs).length > 0;
}
